import axios from '../api' // 倒入 api

// 获取组织列表
const getGroupList = () => {
  return axios({
    url: '/api/group',
    method: 'GET',
  })
}

//新增分组
const addMonitorGroup = (data) => {
  return axios({
    url: '/api/group',
    method: 'POST',
    data
  })
}
//删除分组
const delMonitorGroup = (groupId) => {
  return axios({
    url: `/api/group/${groupId}`,
    method: 'DELETE',
  })
}

//编辑分组
const modifyMonitorGroup = (groupId,data) => {
  return axios({
    url: `/api/group/${groupId}`,
    method: 'PUT',
    data
  })
}

// 获取设备列表
const getDeviceList = (data) => {
  return axios({
    url: '/api/device',
    method: 'POST',
    data
  })
} 

//设备移动分组
const moveDevice = (data) => {
  return axios({
    url: '/api/group/hardware',
    method: 'POST',
    data
  })
}
//设备获取位置列表
const getVehiclePos = (data) => {
  return axios({
    url: '/api/location',
    method: 'POST',
    data
  })
}

//获取单个设备的详细信息
const getDeviceDetail = (params) => {
  return axios({
    url: '/api/device/location',
    method: 'GET',
    params
  })
}

//数字钥匙 最近操作日志
const commandHis = (data) => {
  return axios({
    url: '/api/uKey/command/command/his',
    method: 'POST',
    data
  })
}

//数字钥匙 获取绑定关系
const getBindCarDriver = (params) => {
  return axios({
    url: '/api/uKey/command/getBindCarDriver',
    method: 'GET',
    params
  })
}

//数字钥匙 保存绑定关系
const bindCarDriver = (data) => {
  return axios({
    url: '/api/uKey/command/bindCarDriver',
    method: 'POST',
    data
  })
}

//数字钥匙 车门落锁
const commandDoorlock = (data) => {
  return axios({
    url: '/api/uKey/command/door_lock',
    method: 'POST',
    data
  })
}

//数字钥匙 车门开锁
const commandDooropen = (data) => {
  return axios({
    url: '/api/uKey/command/door_open',
    method: 'POST',
    data
  })
}

//数字钥匙 指令结果查询
const commandResult = (params) => {
  return axios({
    url: '/api/uKey/command/result',
    method: 'GET',
    params
  })
}

//设置回传指令
const postReturnCommand = (data) => {
  return axios({
    url: '/api/command/return',
    method: 'POST',
    data
  })
}
// WY510 上传间隔
const uploadIntervalNewEquipment = (data) => {
  return axios({
    url: `/api/command/${data.type}`,
    method: 'POST',
    data
  })
}

//发送油电控制指令
const postPetrolCommand = (data) => {
  return axios({
    url: '/api/command/petrol',
    method: 'POST',
    data
  })
}
//工作模式指令
const postWorkingCommand = (data) => {
  return axios({
    url: '/api/command/common',
    method: 'POST',
    data
  })
}

const getVehicleLine = (data) => {
  return axios({
    url: '/api/line/car',
    method: 'POST',
    data
  })
}

const getVehicleArea = (data) => {
  return axios({
    url: '/api/area/car',
    method: 'POST',
    data
  })
}

//区域查车
const getArealocaltion = (data) => {
  return axios({
    url: '/api/area/location',
    method: 'POST',
    data
  })
}

//常规报警
const getRoutineAlarmList = (data) => {
  return axios({
    url: '/api/plc/time/monitor/v2',
    method: 'POST',
    data
  })
}

//获取常规报警列表
const getNormalWarnList = (data) => {
  return axios({
    url: '/api/warn',
    method: 'POST',
    data
  })
}

//获取指令下发记录
const getCommandHistory = (data) => {
  return axios({
    url: '/api/command/history',
    method: 'POST',
    data
  })
}

//获取轨迹回放页面日历
const getReplayCalendar = (data) => {
  return axios({
    url: '/api/replay/calendar',
    method: 'POST',
    data
  })
}

//获取轨迹回放
const getReplayList = (data) => {
  return axios({
    url: '/api/replay/list',
    method: 'POST',
    data
  })
}

//获取轨迹定位数据
const getReplayLocaltion = (data) => {
  return axios({
    url: '/api/replay/location',
    method: 'POST',
    data
  })
}

//获取轨迹行驶段数据
const getReplayTravel = (data) => {
  return axios({
    url: '/api/replay/travel',
    method: 'POST',
    data
  })
}

//获取轨迹停止段数据
const getReplayPark = (data) => {
  return axios({
    url: '/api/replay/parking',
    method: 'POST',
    data
  })
}

//获取轨迹报警数据
const getReplayAlarm = (data) => {
  return axios({
    url: '/api/replay/alarm',
    method: 'POST',
    data
  })
}

//获取路线列表
const getMonitorLine = (data) => {
  return axios({
    url: '/api/line/list',
    method: 'POST',
    data
  })
}

//添加路线
const addMonitorLine = (data) => {
  return axios({
    url: '/api/line',
    method: 'POST',
    data
  })
}

//修改路线
const modifyMonitorLine = (data) => {
  return axios({
    url: '/api/line',
    method: 'PUT',
    data
  })
}

//修改路线
const deleteMonitorLine = (areaId) => {
  return axios({
    url: `/api/line/${areaId}`,
    method: 'DELETE',
  })
}

//获取地图位置点
const getMonitorPoint = (data) => {
  return axios({
    url: `/api/point/list`,
    method: 'POST',
    data
  })
}

//获取地图位置点
const addMonitorPoint = (data) => {
  return axios({
    url: `/api/point`,
    method: 'POST',
    data
  })
}

//修改路线
const deleteMonitoPoint = (pointId) => {
  return axios({
    url: `/api/point/${pointId}`,
    method: 'DELETE',
  })
}

//获取地图区域列表
const getMonitorArea = (data) => {
  return axios({
    url: `/api/area/list`,
    method: 'POST',
    data
  })
}

//获取行政区域列表
const getRegionList = (data) => {
  return axios({
    url: `/api/area/list/district`,
    method: 'POST',
    data
  })
}

const addMonitorArea = (data) => {
  return axios({
    url: `/api/area`,
    method: 'POST',
    data
  })
}

const modifyMonitorArea = (data) => {
  return axios({
    url: `/api/area`,
    method: 'PUT',
    data
  })
}

const delMonitorArea = (areaId) => {
  return axios({
    url: `/api/area/${areaId}`,
    method: 'DELETE',
  })
}

//获取绑定车辆
const getBindArea = (areaId) => {
  return axios({
    url: `/api/area/bind/${areaId}`,
    method: 'GET',
  })
}

//区域绑定车辆
const areaBindVehicle = (data) => {
  return axios({
    url: `/api/area/bind`,
    method: 'PUT',
    data
  })
}

//获取报警记录列表
const getAlarmList = (params) => {
  return axios({
    url: `/api/alarm/page`,
    method: 'GET',
    params
  })
}

//获取报警记录详情
const getAlarmDetail = (alarmId) => {
  return axios({
    url: `/api/alarm/${alarmId}`,
    method: 'GET',
  })
}

//获取报警处理详情
const alarmProcessDetail = (alarmIdString) => {
  return axios({
    url: `/api/alarm/page/child?alarmIdString=${alarmIdString}`,
    method: 'GET',
  })
}

//报警处理
const alarmProcess = (data) => {
  return axios({
    url:`/api/alarm/process/batch`,
    method: 'POST',
    data
  })
}

//报警类型处理
const alarmType = (params) => {
  return axios({
    url:`/api/alarm/manual/type`,
    method: 'get',
    params
  })
}
//报警手动，自动
const alarmSet = (data) =>{
  return axios({
    url:`/api/alarm/manual/type/set`,
    method: 'post',
    data
  })
}
//报警批量处理
const alarmProcessBatch = (data) => {
  return axios({
    url: `/api/alarm/process/batch`,
    method: 'PUT',
    data
  })
}

//获取报警设置详情
const getAlarmSettingDetail = () => {
  return axios({
    url: `/api/alarm/set`,
    method: 'GET',
  })
}

//报警设置
const AlarmSetting = (data) => {
  return axios({
    url: `/api/alarm/set`,
    method: 'put',
    data
  })
}

//轨迹回放统计
const getReplayReport = (data) => {
  return axios({
    url: `/api/replay/report`,
    method: 'POST',
    data
  })
}

// 获取加油点
const getFuelPoint = (data) => {
  return axios({
    url: `/api/replay/addoil`,
    method: 'POST',
    data
  })
}

// 获取漏油点
const getLeakPoint = data => {
  return axios({
    url: `/api/replay/oilLeakage`,
    method: 'POST',
    data
  })
}

const getPosAddress = (params) => {
  return axios({
    url: `/api/address`,
    method: 'GET',
    params
  })
}

const getLocSearch = (params) => {
  return axios({
    url: `/api/location/carSearch`,
    method: 'GET',
    params
  })
}
// /location/carSearch

// 默认全部倒出
// 根绝需要进行
export default {
  getGroupList,
  getDeviceList,
  addMonitorGroup,
  delMonitorGroup,
  modifyMonitorGroup,
  moveDevice,
  getVehiclePos,
  getDeviceDetail,
  commandHis,
  getBindCarDriver,
  bindCarDriver,
  commandDoorlock,
  commandDooropen,
  commandResult,
  postReturnCommand,
  uploadIntervalNewEquipment,
  postPetrolCommand,
  postWorkingCommand,
  getVehicleLine,
  getVehicleArea,
  getArealocaltion,
  getRoutineAlarmList,
  getNormalWarnList,
  getCommandHistory,
  getReplayCalendar,
  getReplayList,
  getReplayLocaltion,
  getReplayTravel,
  getReplayPark,
  getReplayAlarm,
  addMonitorLine,
  getMonitorLine,
  modifyMonitorLine,
  deleteMonitorLine,
  getMonitorPoint,
  addMonitorPoint,
  deleteMonitoPoint,
  getMonitorArea,
  addMonitorArea,
  getRegionList,
  modifyMonitorArea,
  delMonitorArea,
  getBindArea,
  areaBindVehicle,
  getAlarmList,
  getAlarmDetail,
  alarmProcessDetail,
  alarmProcess,
  getAlarmSettingDetail,
  AlarmSetting,
  alarmProcessBatch,
  getReplayReport,
  getFuelPoint,
  getLeakPoint,
  getPosAddress,
  getLocSearch,
  alarmType,
  alarmSet
}
